import { transporte } from 'cifra-api-js';
import ComponentesJQuery from '../../../mixins/cifra/ComponentesJQuery';
import SelectorTurno from './SelectorTurno.vue';
import SelectorParada from './SelectorParada.vue';
import SelectorAsiento from './SelectorAsiento.vue';
import Overlay from '../../../libs/cifra/overlay';
import { onlyISODate } from '../../../libs/dates';

export default {
  template: '#eventual-form-template',
  mixins: [ComponentesJQuery],
  components: {
    SelectorTurno, SelectorParada, SelectorAsiento,
  },
  props: ['usuarioId', 'url'],
  data() {
    return {
      fecha: onlyISODate(new Date()),
      turnoSeleccionado: {},
      paradaSeleccionada: null,
      asientoSeleccionado: null,
      guardando: false,
    };
  },
  computed: {
    puedeGuardar() {
      return this.paradaSeleccionada && this.asientoSeleccionado;
    },
    paramsTurnos() {
      return {
        fecha: this.fecha,
      };
    },
  },
  watch: {
    turnoSeleccionado() {
      this.clearParada();
    },
  },
  methods: {
    clearParada() {
      this.paradaSeleccionada = null;
      this.asientoSeleccionado = null;
    },
    guardar() {
      const overlay = new Overlay(this.$el);
      overlay.show();
      this.guardando = true;
      const data = {
        usuario_id: this.usuarioId,
        fecha: this.fecha,
        turno_id: this.turnoSeleccionado.id,
        parada_id: this.paradaSeleccionada,
        asiento: this.asientoSeleccionado,
      };
      transporte.eventuales.guardar(data).then(() => {
      }).catch(() => {
      }).finally(() => {
        this.guardando = false;
        overlay.hide();
      });
    },
  },
};
